import React from 'react';
import EducationComponent from '../components/Education';

function Education() {
  return (
    <div className="animate-fade-in-up">
      <EducationComponent />
    </div>
  );
}

export default Education;
